import RepurchaseDefinition from '../../shared/partials/repurchase-definition.en.mdx';

export const title = 'Repurchases (Chart)';

Chart showing the number of repurchases over time. The chart separates repurchases into two categories:
- **In-app repurchases:** from customers who purchased 2+ times via the app
- **Channel migration:** from customers who previously bought on your website and made their first purchase via the app